export default {"src":"/_next/static/media/close-x.bf5b9315.svg","height":14,"width":14};